import { render, staticRenderFns } from "./phoneImportTemplate.vue?vue&type=template&id=2641c976&scoped=true&"
import script from "./phoneImportTemplate.vue?vue&type=script&lang=js&"
export * from "./phoneImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./phoneImportTemplate.vue?vue&type=style&index=0&id=2641c976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641c976",
  null
  
)

export default component.exports